import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

// const supportedLngs = ['it', 'en', 'fr', 'ru', 'pt', 'de', 'es', 'nl', 'sq', 'zh', 'ja'];
const supportedLngs = ['it'];
const fallbackLng = 'it';

i18n
  .use(LanguageDetector)
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    supportedLngs: supportedLngs,
    fallbackLng: fallbackLng,
    load: 'languageOnly',
    detection: {
      order: ['path', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      lookupFromPathIndex: 0,
      caches: ['cookie', 'localStorage'],
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    initImmediate: false,
    react: {
      useSuspense: false,
    },
  });

export default i18n;